import React from "react";
import {Page, Text, Document} from '@react-pdf/renderer';
import PropTypes from "prop-types";

import getPrintColors from "./printDocumentStyles";
import PrintDocumentHeader from "./printDocumentHeader";
import PrintDocumentInfo from "./printDocumentInfo";
import PrintDocumentBody from "./printDocumentBody";
import PrintDocumentTotal from "./printDocumentTotal";
import PrintDocumentSignature from "./printDocumentSignature";
import PrintDocumentDiscountsList from "./printDocumentDiscountsList";
import {PrintDocumentContext} from "./printDocumentContext";
import {TRANSLATES} from "../../../translatesProvider";
import PrintDocumentDisclaimer from "./printDocumentDisclaimer";
import PrintDocumentAsCentralText from "./printDocumentAsCentralText";

// import PropTypes from "prop-types";
// import {FormattedMessage} from "react-intl";

const PrintDocument = (props) => {
  const {fabricatorData, userInfo, quotes, cartItems, discountSections, jobId, assignQuotePopupCustomer,
    employeeSelected, locale, filterGroups, activeTheme, printLogo, wizardState, sqftSlabState, cartItemsThumbnails,
    printState, onRender, isContractSign} = props;

  const styles = getPrintColors(activeTheme);

  return (
    <Document onRender={onRender}>
      <PrintDocumentContext.Provider value={{messages: TRANSLATES}}>
        <Page style={fabricatorData.isAmericanStandard ? styles.pageAS : styles.page}
              object-fit="fill"
              size="A4">
          <PrintDocumentHeader fabricatorData={fabricatorData} jobId={jobId} styles={styles} printLogo={printLogo}/>
          <PrintDocumentInfo userInfo={userInfo}
                             fabricatorData={fabricatorData}
                             assignQuotePopupCustomer={assignQuotePopupCustomer}
                             employeeSelected={employeeSelected}
                             styles={styles}/>
          {fabricatorData.isAmericanStandard ? <PrintDocumentAsCentralText styles={styles}/> : null}
          <PrintDocumentBody quotes={quotes}
                             cartItemsThumbnails={cartItemsThumbnails}
                             cartItems={cartItems}
                             locale={locale}
                             fabricatorData={fabricatorData}
                             filterGroups={filterGroups}
                             wizardState={wizardState}
                             sqftSlabState={sqftSlabState}
                             styles={styles}/>
          {discountSections.length ? (
            <PrintDocumentDiscountsList discountSections={discountSections}
                                        fabricatorSettings={fabricatorData.settings}
                                        styles={styles}/>
          ) : null}
          <PrintDocumentTotal discountSections={discountSections}
                              fabricatorData={fabricatorData}
                              locale={locale}
                              cartItems={cartItems}
                              styles={styles}/>
          <PrintDocumentDisclaimer withTotal={false}
                                   styles={styles}
                                   locale={locale}
                                   discountSections={discountSections}
                                   fabricatorData={fabricatorData}/>
          <PrintDocumentSignature styles={styles}
                                  userInfo={userInfo}
                                  locale={locale}
                                  assignQuotePopupCustomer={assignQuotePopupCustomer}
                                  isContractSign={isContractSign}
                                  receiptSignature={printState.receiptSignature}/>
          <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
            `${pageNumber} / ${totalPages}`
          )} fixed />
        </Page>
      </PrintDocumentContext.Provider>
    </Document>
  )
};

PrintDocument.propTypes = {
  quotes: PropTypes.array.isRequired,
  cartItems: PropTypes.array.isRequired,
  discountSections: PropTypes.array.isRequired,
  userInfo: PropTypes.object.isRequired,
  fabricatorData: PropTypes.object.isRequired,
  jobId: PropTypes.number,
  assignQuotePopupCustomer: PropTypes.object,
  employeeSelected: PropTypes.object,
  locale: PropTypes.string.isRequired,
  activeTheme: PropTypes.string,
  printLogo: PropTypes.string,
  wizardState: PropTypes.object.isRequired,
  isContractSign: PropTypes.bool,
  printState: PropTypes.object,
};

export default PrintDocument
